import { defineMessages } from '@atlassian/jira-intl';

export const messages: {
	dropdownButtonTooltip: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	dataAndPrivacy: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	overflowMenuLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	dropdownButtonTooltip: {
		id: 'jql-builder-with-ai.natural-language-to-jql-wrapper.jql-builder-embedded.search-mode-switcher.search-mode-overflow-menu.dropdown-button-tooltip',
		defaultMessage: 'More actions',
		description: 'Tooltip text to display when hovering the dropdown menu button',
	},
	dataAndPrivacy: {
		id: 'jql-builder-with-ai.natural-language-to-jql-wrapper.jql-builder-embedded.search-mode-switcher.search-mode-overflow-menu.data-and-privacy',
		defaultMessage: 'Data & Privacy',
		description: 'Button text to display for the link to privacy & legal page',
	},
	overflowMenuLabel: {
		id: 'jql-builder-with-ai.natural-language-to-jql-wrapper.jql-builder-embedded.search-mode-switcher.search-mode-overflow-menu.overflow-menu-label',
		defaultMessage: 'More query builder options',
		description:
			'Accessible label read by screen readers for the query builder more options dropdown menu',
	},
});
